import React from "react";
import styled from "styled-components";
import { useGlobalModal } from "../../../contexts/GlobalModalContext";
import { ManualFixContent } from "./ManualFixContent";

const ModalBodyStyle = styled.div.attrs(() => ({
    className: "m-4",
}))``;

type ManualFixModalBodyProps = {
    personnelId: number;
    personnel: any;
};

const ManualFixModalBody: React.FC<ManualFixModalBodyProps> = ({ personnelId, personnel }) => {
    const { dispatch, closeModal } = useGlobalModal();

    return (
        <ModalBodyStyle>
            <ManualFixContent
                personnelId={personnelId}
                personnel={personnel}
                isStandalone={true}
                onClose={() => closeModal()}
                onActionStateChange={actionState => {
                    // Update global modal state when actions change
                    if (actionState.consentFormAction) {
                        dispatch({
                            type: "updateConsentFormAction",
                            action: actionState.consentFormAction,
                        });
                    }
                    if (actionState.statusChangeAction) {
                        dispatch({
                            type: "updateStatusChangeAction",
                            action: actionState.statusChangeAction,
                        });
                    }
                    if (actionState.newStatus) {
                        dispatch({ type: "updateNewStatus", status: actionState.newStatus });
                    }
                    if (actionState.selectedResendConsentFormId) {
                        dispatch({
                            type: "updateSelectedResendConsentFormId",
                            consentFormId: actionState.selectedResendConsentFormId,
                        });
                    }
                    if (actionState.selectedCancelConsentFormId) {
                        dispatch({
                            type: "updateSelectedCancelConsentFormId",
                            consentFormId: actionState.selectedCancelConsentFormId,
                        });
                    }
                }}
            />
        </ModalBodyStyle>
    );
};

type ManualFixModalFooterProps = {
    personnelId: number;
    consentFormAction: string;
    backgroundCheckAction: string;
    backgroundCheckJurisdiction: string;
    statusChangeAction: string;
    newStatus: string;
    selectedResendConsentFormId: string;
    selectedCancelConsentFormId: string;
};

const ManualFixModalFooter: React.FC<ManualFixModalFooterProps> = () => {
    // No footer buttons needed - all actions are handled directly in ManualFixContent:
    // - Status Change has its own inline Submit button
    // - Consent Form actions use action menus (resend/cancel)
    // - Background Check actions use action menus
    // - Questionnaire has "Resend Questionnaire" button
    // - "Send New Consent Forms" and per-jurisdiction send buttons in ManualFixContent
    // All actions close the modal on success via their individual handlers
    return null;
};

ManualFixModalBody.displayName = "BodyContent";
ManualFixModalFooter.displayName = "FooterContent";

export { ManualFixModalBody, ManualFixModalFooter };
